import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-262">
      {children}
    </motion.div>;
}
export function OfferSection() {
  const scrollToPrice = () => {
    const el = document.getElementById('price-block');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  const handleBuyNow = () => {
    trackAddToCart({
      content_name: 'El Código de la Longevidad Bíblica',
      content_type: 'product',
      value: 27,
      currency: 'USD'
    });
    window.open('https://www.contenidodigitalpro.com/cart/47030470738069:1', '_blank');
  };
  return <section id="offer" className="w-full py-24 px-4 relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 0%, #132040 0%, #0a1628 60%)'
  }} data-id="element-263">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--color-gold), transparent)'
    }} data-id="element-264" />

      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full blur-3xl opacity-10 pointer-events-none" style={{
      background: 'var(--color-gold)'
    }} data-id="element-265" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-266">
        <FadeInUp data-id="element-267">
          <div className="text-center mb-10" data-id="element-268">
            <div className="section-divider mb-6" data-id="element-269">
              <span className="ornament" data-id="element-270">✦</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-271">
              Tu Restauración Comienza
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-272">
                Hoy
              </span>
            </h2>
            <p className="font-body text-lg leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-273">
              Queremos que esta sabiduría llegue a cada rincón donde se necesite
              restauración profunda.
            </p>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.15} data-id="element-274">
          <div className="rounded-2xl p-8 md:p-10 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.08) 0%, rgba(15, 31, 61, 0.95) 50%, rgba(74, 158, 255, 0.05) 100%)',
          border: '1px solid rgba(201, 168, 76, 0.4)',
          boxShadow: '0 0 60px rgba(201, 168, 76, 0.1), 0 20px 60px rgba(0,0,0,0.5)'
        }} data-id="element-275">
            {/* Corner ornaments */}
            <div className="absolute top-4 left-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-276">
              ✦
            </div>
            <div className="absolute top-4 right-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-277">
              ✦
            </div>
            <div className="absolute bottom-4 left-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-278">
              ✦
            </div>
            <div className="absolute bottom-4 right-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-279">
              ✦
            </div>

            {/* What's included */}
            <div className="mb-8" data-id="element-280">
              <h3 className="font-heading font-600 text-xl mb-5 text-center" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-281">
                Incluye Todo el Sistema:
              </h3>
              <div className="space-y-3" data-id="element-282">
                <div className="flex items-center gap-3" data-id="element-283">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-284">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-285">
                    El Manual Maestro (100 páginas)
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-286">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-287">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-288">
                    Protocolo de 21 Días completo
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-289">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-290">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-291">
                    Guía de los 7 Superalimentos
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-292">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-293">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-294">
                    Rutina "Templo de Piedra"
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-295">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-296">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-297">
                    Lista de Compras Génesis
                  </span>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="h-px mb-8" style={{
            background: 'linear-gradient(90deg, transparent, rgba(201, 168, 76, 0.3), transparent)'
          }} data-id="element-298" />

            {/* Price */}
            <div id="price-block" className="text-center mb-8" data-id="element-299">
              <p className="font-body text-sm tracking-widest uppercase mb-2" style={{
              color: 'var(--color-cream-muted)'
            }} data-id="element-300">
                Inversión única hoy
              </p>
              <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-301">
                <span className="font-heading font-700 text-7xl leading-none shimmer-text" data-id="element-302">
                  $27
                </span>
                <span className="font-body text-xl" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-303">
                  USD
                </span>
              </div>
              <p className="font-body text-sm" style={{
              color: 'var(--color-cream-muted)'
            }} data-id="element-304">
                Una fracción del costo de una consulta privada
              </p>
            </div>

            {/* CTA Button */}
            <motion.button onClick={handleBuyNow} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="cta-button w-full py-5 px-8 rounded-xl font-body font-700 text-xl uppercase tracking-wider" style={{
            background: 'linear-gradient(135deg, #C9A84C 0%, #E8C96A 50%, #C9A84C 100%)',
            color: '#0a1628',
            backgroundSize: '200% auto'
          }} data-id="element-305">
              ✦ Sí, Quiero Restaurar Mi Vitalidad Ahora ✦
            </motion.button>

            {/* Trust signals */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6" data-id="element-306">
              <div className="flex items-center gap-2" data-id="element-307">
                <span className="text-lg" data-id="element-308">🔒</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-309">
                  Transacción 100% segura
                </span>
              </div>
              <div className="hidden sm:block w-px h-4" style={{
              background: 'rgba(201, 168, 76, 0.2)'
            }} data-id="element-310" />
              <div className="flex items-center gap-2" data-id="element-311">
                <span className="text-lg" data-id="element-312">⚡</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-313">
                  Acceso inmediato tras el pago
                </span>
              </div>
              <div className="hidden sm:block w-px h-4" style={{
              background: 'rgba(201, 168, 76, 0.2)'
            }} data-id="element-314" />
              <div className="flex items-center gap-2" data-id="element-315">
                <span className="text-lg" data-id="element-316">🛡️</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-317">
                  100% privado
                </span>
              </div>
            </div>
          </div>
        </FadeInUp>

        {/* Final message */}
        <FadeInUp delay={0.3} data-id="element-318">
          <div className="text-center mt-12" data-id="element-319">
            <p className="font-heading text-xl italic font-400 leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-320">
              "No fuiste diseñado para pasar tus mejores años dependiendo de una
              bandeja de pastillas o temiendo perder tu autonomía."
            </p>
            <div className="gold-divider mt-6" data-id="element-321" />
          </div>
        </FadeInUp>
      </div>

      {/* Bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--color-gold-dim), transparent)'
    }} data-id="element-322" />
    </section>;
}